import { FC } from 'react';
import { Image, Stack } from '@chakra-ui/react';

import fadedFlowerImg from 'assets/brand/faded-flower@2x.png';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

import { Request } from '../../../../hooks/useRequests';
import locales from './locales';

interface RequestRejectedProps {
  request: Request;
}

const RequestRejected: FC<RequestRejectedProps> = ({ request }) => (
  <Stack spacing="space-16">
    <Image alt="" boxSize="120px" role="presentation" src={fadedFlowerImg} />

    <Heading>{locales.title}</Heading>

    {request.requester ? (
      <Text>
        {locales.formatString(locales.description, request.requester)}
      </Text>
    ) : null}
  </Stack>
);

export default RequestRejected;
